import { useEffect } from 'react'
import { collection, onSnapshot } from 'firebase/firestore'
import useStore from '../store/useStore'
import { getEffectiveServices } from '../utils/firebaseServiceContext'

const useFetchContent = () => {
  const identityStatus = useStore((state) => state.identityStatus)
  useEffect(() => {
    if (!['primary', 'impersonating'].includes(identityStatus)) return
    const unsubscribe = onSnapshot(
      collection(getEffectiveServices().firestore, 'content'),
      (snap) => {
        const content: any = {}

        snap.forEach((doc) => {
          if (doc.id === 'purpleBubbles') {
            const data = doc.data()
            content.purpleBubbles = data.contentBlocks
          } else {
            content[doc.id] = doc.data()
          }
        })

        useStore.setState({ content })
      }
    )

    return () => unsubscribe()
  }, [identityStatus])
}

export default useFetchContent
